/* ==========================================================================
   ZPK — Immagini a schermo intero della scheda prodotto
   Markup in sections/zpk-product-main.liquid, stile in zpk-lightbox.css.

   Si apre toccando la copertina. Dentro:
   - frecce, miniature, tasti ← → Home Fine, scorrimento col dito;
   - zoom: clic o tocco sulla foto, rotella, pizzico con due dita, tasti + e −,
     bottone in alto; con lo zoom attivo la foto si sposta trascinandola o
     con le frecce della tastiera;
   - si chiude con Esc, col bottone in alto o toccando il fondo scuro.
   Alla chiusura la pagina mostra la stessa foto che si stava guardando e il
   fuoco torna sulla copertina.
   Anche la copertina della pagina, con piu' foto, si sfoglia: frecce ai lati
   e scorrimento col dito.
   ========================================================================== */
(function () {
  'use strict';

  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const TAP = 8;          // px: sotto questo spostamento e' un tocco, non un trascinamento
  const SWIPE = 60;       // px: da qui in su lo scorrimento cambia foto
  const TAP_ZOOM = 2.5;   // ingrandimento del clic/tocco sulla foto
  const MAX_ZOOM = 4;
  const PAN_STEP = 80;    // px per pressione di freccia con lo zoom attivo

  function setup(dialog) {
    if (dialog.dataset.zpkBound) return;
    dialog.dataset.zpkBound = '1';

    const gallery = dialog.closest('[data-zpk-gallery]');
    const stage = $('[data-zpk-lightbox-stage]', dialog);
    const slides = $$('[data-zpk-lightbox-slide]', dialog);
    const thumbs = $$('[data-zpk-lightbox-thumb]', dialog);
    const count = $('[data-zpk-lightbox-count]', dialog);
    const status = $('[data-zpk-lightbox-status]', dialog);
    const zoomBtn = $('[data-zpk-lightbox-zoom]', dialog);
    const total = slides.length;
    if (!stage || !total) return;

    let index = 0;
    let opener = null;
    let z = 1, tx = 0, ty = 0;

    const img = () => $('img', slides[index]);

    /* --- Zoom e spostamento ------------------------------------------------
       La foto e' centrata nel palco: il suo stato e' un ingrandimento `z` e
       uno spostamento (tx, ty) dal centro. I punti arrivano in coordinate
       rispetto al centro del palco. */
    function center() {
      const r = stage.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }

    function clamp() {
      const el = img();
      const mx = Math.max(0, (el.offsetWidth * z - stage.clientWidth) / 2);
      const my = Math.max(0, (el.offsetHeight * z - stage.clientHeight) / 2);
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    }

    function apply(animate) {
      const el = img();
      el.classList.toggle('is-animating', !!animate);
      el.style.transform = (z === 1 && !tx && !ty) ? '' : `translate(${tx}px, ${ty}px) scale(${z})`;
      stage.classList.toggle('is-zoomed', z > 1);
      if (zoomBtn) zoomBtn.setAttribute('aria-pressed', String(z > 1));
    }

    // Alla prima volta che si ingrandisce si chiede al browser la versione
    // piu' grande dell'immagine: con `sizes` piu' largo sceglie un'altra voce
    // del srcset e intanto continua a mostrare quella che ha.
    function sharpen() {
      const el = img();
      if (z > 1 && !el.dataset.zpkSharp) {
        el.dataset.zpkSharp = '1';
        el.sizes = Math.ceil(el.offsetWidth * MAX_ZOOM) + 'px';
      }
    }

    // Ingrandisce a `next` tenendo fermo sotto il puntatore il punto (px, py).
    function zoomTo(next, px, py, animate) {
      next = Math.min(MAX_ZOOM, Math.max(1, next));
      if (next < 1.02) next = 1;
      tx = px - (next * (px - tx)) / z;
      ty = py - (next * (py - ty)) / z;
      z = next;
      if (z === 1) { tx = 0; ty = 0; }
      clamp();
      sharpen();
      apply(animate);
    }

    function pan(dx, dy) {
      tx += dx; ty += dy;
      clamp();
      apply(true);
    }

    function resetZoom() {
      z = 1; tx = 0; ty = 0;
      slides.forEach((s) => {
        const el = $('img', s);
        el.style.transform = '';
        el.classList.remove('is-animating');
      });
      stage.classList.remove('is-zoomed');
      if (zoomBtn) zoomBtn.setAttribute('aria-pressed', 'false');
    }

    /* --- Cambio foto ------------------------------------------------------- */
    function show(next, dir) {
      index = (next + total) % total;
      resetZoom();
      slides.forEach((s, i) => {
        const on = i === index;
        s.classList.toggle('is-active', on);
        s.classList.remove('is-next', 'is-prev');
        s.inert = !on;
        s.setAttribute('aria-hidden', String(!on));
      });
      if (dir) {
        const s = slides[index];
        void s.offsetWidth; // riparte l'animazione anche se la classe era gia' stata usata
        s.classList.add(dir > 0 ? 'is-next' : 'is-prev');
      }
      thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === index)));
      const current = thumbs[index];
      if (current && dialog.open) current.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (count) count.textContent = String(index + 1);
      if (status && dialog.open) status.textContent = `Immagine ${index + 1} di ${total}`;
    }

    const go = (step) => show(index + step, step);

    /* --- Apertura e chiusura ------------------------------------------------ */
    // `trigger` e' la copertina premuta: il fuoco torna li' anche nei browser
    // (Safari) che col clic non lo danno al bottone.
    function open(at, trigger) {
      if (dialog.open) return;
      opener = trigger || document.activeElement;
      if (status) status.textContent = '';
      show(at || 0);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      const current = thumbs[index];
      if (current) current.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
    dialog.zpkOpen = open;

    // Dopo la chiusura la pagina mostra la foto su cui ci si e' fermati e il
    // fuoco torna alla copertina. Si puo' chiamare due volte senza danni: la
    // chiudono i comandi qui sotto (subito) e l'evento `close` del <dialog>
    // (per le chiusure del browser, come il tasto Indietro su Android; e'
    // un evento che Chrome puo' ritardare quando la scheda non e' in vista).
    function afterClose() {
      if (dialog.open) return; // evento ritardato arrivato dopo una nuova apertura
      const pageThumb = gallery && $$('[data-zpk-gallery-thumb][data-zpk-lightbox-index]', gallery)
        .find((t) => Number(t.dataset.zpkLightboxIndex) === index);
      if (pageThumb && pageThumb.getAttribute('aria-current') !== 'true') pageThumb.click();
      resetZoom();
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    }
    function shut() {
      if (dialog.open) dialog.close();
      afterClose();
    }
    dialog.addEventListener('close', afterClose);

    $('[data-zpk-lightbox-close]', dialog)?.addEventListener('click', shut);
    $('[data-zpk-lightbox-prev]', dialog)?.addEventListener('click', () => go(-1));
    $('[data-zpk-lightbox-next]', dialog)?.addEventListener('click', () => go(1));
    thumbs.forEach((t, i) => t.addEventListener('click', () => { if (i !== index) show(i, i > index ? 1 : -1); }));
    zoomBtn?.addEventListener('click', () => zoomTo(z > 1 ? 1 : TAP_ZOOM, 0, 0, true));

    /* --- Tastiera ----------------------------------------------------------
       Con lo zoom attivo le frecce spostano la foto, altrimenti la cambiano.
       Esc lo gestirebbe gia' il <dialog>, ma non sempre: un Esc che non arriva
       come «richiesta di chiusura» del browser (tastiere virtuali, alcuni
       strumenti di accessibilita') lascia la finestra aperta. */
    dialog.addEventListener('keydown', (e) => {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      switch (e.key) {
        case 'Escape':
          shut();
          break;
        case 'ArrowLeft':
          if (z > 1) pan(PAN_STEP, 0); else if (total > 1) go(-1); else return;
          break;
        case 'ArrowRight':
          if (z > 1) pan(-PAN_STEP, 0); else if (total > 1) go(1); else return;
          break;
        case 'ArrowUp':
          if (z > 1) pan(0, PAN_STEP); else return;
          break;
        case 'ArrowDown':
          if (z > 1) pan(0, -PAN_STEP); else return;
          break;
        case '+': case '=':
          zoomTo(z * 1.5, 0, 0, true);
          break;
        case '-': case '_':
          zoomTo(z / 1.5, 0, 0, true);
          break;
        case '0':
          zoomTo(1, 0, 0, true);
          break;
        case 'Home':
          if (total > 1 && index !== 0) show(0, -1); else return;
          break;
        case 'End':
          if (total > 1 && index !== total - 1) show(total - 1, 1); else return;
          break;
        default:
          return;
      }
      e.preventDefault();
    });

    /* --- Mouse, dito, penna -------------------------------------------------
       Un tocco senza spostamento: sulla foto ingrandisce (o torna indietro se
       e' gia' ingrandita), sul fondo chiude. Un trascinamento: con lo zoom
       sposta la foto, senza zoom cambia foto. Due dita: pizzico. */
    const pointers = new Map();
    let gesture = null;
    const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
    const mid = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });

    stage.addEventListener('dragstart', (e) => e.preventDefault());

    stage.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      try { stage.setPointerCapture(e.pointerId); } catch (err) { /* puntatore gia' rilasciato */ }
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 1) {
        gesture = { x0: e.clientX, y0: e.clientY, tx0: tx, ty0: ty, moved: false, pinch: false, target: e.target };
      } else if (pointers.size === 2 && gesture) {
        const [a, b] = Array.from(pointers.values());
        gesture.pinch = true;
        gesture.moved = true;
        gesture.lastDist = dist(a, b);
        gesture.lastMid = mid(a, b);
      }
    });

    stage.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId) || !gesture) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (gesture.pinch && pointers.size >= 2) {
        const [a, b] = Array.from(pointers.values());
        const d = dist(a, b);
        const m = mid(a, b);
        const c = center();
        tx += m.x - gesture.lastMid.x;
        ty += m.y - gesture.lastMid.y;
        zoomTo(z * (d / (gesture.lastDist || d)), m.x - c.x, m.y - c.y, false);
        gesture.lastDist = d;
        gesture.lastMid = m;
        return;
      }

      const dx = e.clientX - gesture.x0;
      const dy = e.clientY - gesture.y0;
      if (!gesture.moved && Math.hypot(dx, dy) < TAP) return;
      gesture.moved = true;
      stage.classList.add('is-dragging');
      if (z > 1) {
        tx = gesture.tx0 + dx;
        ty = gesture.ty0 + dy;
        clamp();
        apply(false);
      } else if (total > 1 && !gesture.afterPinch) {
        tx = dx;
        apply(false);
      }
    });

    function end(e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId);
      if (!gesture) return;

      // Finito il pizzico resta un dito: da qui in poi e' un trascinamento.
      if (pointers.size > 0) {
        if (gesture.pinch && pointers.size === 1) {
          const p = Array.from(pointers.values())[0];
          gesture = { x0: p.x, y0: p.y, tx0: tx, ty0: ty, moved: true, pinch: false, afterPinch: true };
        }
        return;
      }

      const g = gesture;
      gesture = null;
      stage.classList.remove('is-dragging');

      if (e.type === 'pointercancel') {
        if (z === 1 && tx) { tx = 0; apply(true); }
        return;
      }

      if (!g.moved) {
        if (z > 1) {
          zoomTo(1, 0, 0, true);
        } else if (g.target && g.target.closest('.zpk-lightbox__img')) {
          const c = center();
          zoomTo(TAP_ZOOM, e.clientX - c.x, e.clientY - c.y, true);
        } else {
          shut();
        }
        return;
      }

      if (z === 1 && total > 1 && !g.afterPinch) {
        const dx = e.clientX - g.x0;
        if (Math.abs(dx) > SWIPE) {
          go(dx < 0 ? 1 : -1);
        } else if (tx) {
          tx = 0;
          apply(true);
        }
      }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);

    // Rotella (e pizzico del touchpad, che arriva come rotella con Ctrl).
    stage.addEventListener('wheel', (e) => {
      e.preventDefault();
      const delta = e.deltaY * (e.deltaMode === 1 ? 16 : 1);
      const c = center();
      zoomTo(z * Math.exp(-delta * (e.ctrlKey ? 0.01 : 0.002)), e.clientX - c.x, e.clientY - c.y, false);
    }, { passive: false });

    window.addEventListener('resize', () => {
      if (!dialog.open || z === 1) return;
      clamp();
      apply(false);
    });
  }

  function init(root) {
    $$('[data-zpk-lightbox]', root).forEach(setup);
  }

  /* --- Copertina della pagina: frecce e scorrimento ------------------------
     Cambiano foto premendo la miniatura vicina, cosi' copertina, miniature e
     vista grande restano allineate con la logica che c'e' gia'
     (initGallery in zpk-theme.js). Si gira in tondo: dopo l'ultima, la prima. */
  function stepPage(gallery, step) {
    const row = $('.zpk-gallery__thumbs', gallery);
    const list = $$('[data-zpk-gallery-thumb]', row);
    if (list.length < 2) return;
    const at = Math.max(0, list.findIndex((t) => t.getAttribute('aria-current') === 'true'));
    const next = list[(at + step + list.length) % list.length];
    next.click();
    // Sul telefono la fila di miniature scorre: si porta in vista quella
    // scelta senza muovere la pagina (scrollIntoView la farebbe saltare).
    row.scrollTo({ left: next.offsetLeft - (row.clientWidth - next.offsetWidth) / 2, behavior: 'smooth' });
  }

  document.addEventListener('click', (e) => {
    const arrow = e.target.closest && e.target.closest('[data-zpk-gallery-step]');
    if (!arrow) return;
    const gallery = arrow.closest('[data-zpk-gallery]');
    if (gallery) stepPage(gallery, Number(arrow.dataset.zpkGalleryStep) || 1);
  });

  // Scorrimento col dito sulla copertina (col mouse no: trascinare una foto
  // col mouse vuol dire prenderla, non sfogliarla).
  let swipe = null;
  let swipedAt = 0;
  document.addEventListener('pointerdown', (e) => {
    const cover = e.pointerType !== 'mouse' && e.target.closest && e.target.closest('[data-zpk-lightbox-open]');
    swipe = cover ? { cover, x: e.clientX, y: e.clientY } : null;
  });
  document.addEventListener('pointercancel', () => { swipe = null; });
  document.addEventListener('pointerup', (e) => {
    if (!swipe) return;
    const { cover, x, y } = swipe;
    swipe = null;
    const dx = e.clientX - x;
    const dy = e.clientY - y;
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    const gallery = cover.closest('[data-zpk-gallery]');
    if (!gallery || !$('[data-zpk-gallery-step]', gallery)) return;
    swipedAt = Date.now();
    stepPage(gallery, dx < 0 ? 1 : -1);
  });

  // Delegato sul document: funziona anche dopo che il theme editor ha
  // rimontato la sezione. Si apre sulla foto scelta fra le miniature.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest && e.target.closest('[data-zpk-lightbox-open]');
    if (!trigger) return;
    // Alcuni browser mandano il clic anche alla fine di uno scorrimento.
    if (Date.now() - swipedAt < 400) return;
    const gallery = trigger.closest('[data-zpk-gallery]');
    const dialog = gallery && $('[data-zpk-lightbox]', gallery);
    if (!dialog) return;
    setup(dialog);
    const current = $('[data-zpk-gallery-thumb][aria-current="true"]', gallery);
    dialog.zpkOpen(current ? Number(current.dataset.zpkLightboxIndex) || 0 : 0, trigger);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
